module.exports = __webpack_public_path__ + "img/bookmark.31174a51.svg";